export const CUSTOM_FIELD_CREATE_MODULE_ID = 'custom-field-create-module';

export const LOAD_CUSTOM_FIELD_CREATE_MODULE = () =>
  import('@capital-access/custom-fields/create').then(m => m.CustomFieldsCreationModule);
